export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9591.fd9c0ca5.jpg";